import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { get } from 'lodash';
import { Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import Button from '../../../common/components/Button';
import { required } from '../../../common/services/ValidationRules';
import { BASIC_PROVIDER_TYPE } from '../../../common/constants/authProvider';

import ExternalAuthProviders from './ExternalAuthProviders';
import { FormInput, PasswordField } from '../../../common/components/TextField';
import LoginFormWrapper from './LoginFormWrapper';

function LoginForm({
  handleSubmit,
  isFetching,
  errorMessage,
  submitted,
  pristine,
  config,
  anyTouched,
  reset,
}) {
  const authProviders = get(config, 'authProviders', []);
  let isBasicProvider = authProviders.find((provider) => provider.type === BASIC_PROVIDER_TYPE);
  const externalProviders = authProviders.filter((provider) => provider.type !== BASIC_PROVIDER_TYPE);

  // show basic provider by default if authProviders are missing from settings
  if (!authProviders.length) {
    isBasicProvider = true;
  }

  return (
    <LoginFormWrapper
      isFetching={isFetching}
      error={submitted && anyTouched ? errorMessage : ''}
    >
      {
        isBasicProvider && (
          <form
            className="login-form"
            onSubmit={handleSubmit}
          >
            <Field
              name="username"
              label="Username"
              type="text"
              fullWidth
              disabled={isFetching}
              component={FormInput}
              validate={[required]}
            />
            <Field
              name="password"
              label="Password"
              fullWidth
              disabled={isFetching}
              component={PasswordField}
              validate={[required]}
            />
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="100%"
            >
              <div className="login-form-btns">
                <div className="login-btns">
                  <Button
                    color="primary"
                    type="submit"
                  >
                    Login
                  </Button>
                  <Button
                    color="secondary"
                    className="login-form-clear-btn"
                    disabled={pristine}
                    onClick={() => reset('login')}
                  >
                    Clear
                  </Button>
                </div>
                <Link
                  className="login-form-forgot-password link"
                  component={RouterLink}
                  to="/forgot-password"
                >
                  Forgot your password?
                </Link>
              </div>
            </Box>
          </form>
        )
      }
      <ExternalAuthProviders
        isBasicProvider={isBasicProvider}
        providers={externalProviders}
      />
    </LoginFormWrapper>
  );
}

export default reduxForm({ form: 'login' })(LoginForm);
